import { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function Hero() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const images = [
    '/img/sajies_car1.jpg',
    '/img/sajies_car2.jpg',
    '/img/sajies_car3.jpg',
    '/img/sajies_car4.jpg',
  ];

  useEffect(() => {
    const video = document.createElement('video');
    video.src = './img/Car Rental1.mp4';
    video.onloadeddata = () => setVideoLoaded(true);
    video.onerror = () => setVideoLoaded(false);
  }, []);

  return (
    <div className="w-full h-auto text-white relative overflow-hidden">
      {videoLoaded ? (
        <video autoPlay muted loop className="absolute top-0 left-0 w-full h-[100vh] object-cover opacity-1">
          <source src="./img/Car Rental1.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <Slider {...settings} className="w-full">
          {images.map((img, index) => (
            <div key={index}>
              <img src={img} alt={`Car ${index + 1}`} className="w-full h-[400px] object-cover" />
            </div>
          ))}
        </Slider>
      )}
      <div className="relative z-10 text-center py-16">
        <h1 className="text-4xl sm:text-5xl font-bold mb-4">Welcome to Sajies Global Synergy Limited</h1>
        <p className="text-lg sm:text-xl mb-6 max-w-2xl mx-auto">
          Discover premium vehicles and exceptional services tailored to your needs.
        </p>
        <a href="/browse" className="bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-magenta transition duration-300">
          Explore Now
        </a>
      </div>
    </div>
  );
}
